import guest from '@/middleware/guest'

export default [
	{
		path: '/credenciamento',
		name: 'LawyerRegister',
		meta: {
			title: 'Cadastro de Advogados'
		},
		component: () => import('@/auth/LawyerRegister')
	},
	{
		path: '/login',
		alias: '/',
		name: 'Login',
		meta: {
			title: 'menu.login'
		},
		beforeEnter: guest,
		component: () => import('@/auth/Login')
	},
	{
		path: '/forgot',
		name: 'Forgot',
		meta: {
			title: 'menu.forgot'
		},
		beforeEnter: guest,
		component: () => import('@/auth/Forgot')
	},
	{
		path: '/password/:token',
		name: 'Password',
		meta: {
			title: 'menu.password'
		},
		beforeEnter: guest,
		component: () => import('@/auth/Password')
	},
	{
		path: '*',
		name: 'Error',
		meta: {
			title: 'menu.error'
		},
		component: () => import('@/errors/404')
	}
]
